import wp from '../../assets/CMS/wordpress.png'
const CmsElements = [
    {
      id: 1,
      path:wp,
      title: "WordPress",
      style: "shadow-violet-500",
    },
    
  ];
  export default CmsElements;
  